.row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: 100%;
}

.rowUser {
  flex-direction: row-reverse;
}

.agentAvatar {
  width: 30px;
  height: 30px;
  border-radius: var(--radius-sm);
  object-fit: contain;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  flex-shrink: 0;
  margin-top: 2px;
}

.userAvatar {
  flex-shrink: 0;
  margin-top: 2px;
}

.bubble {
  max-width: min(680px, 78%);
  border-radius: var(--radius-lg);
  padding: 12px 16px;
  box-shadow: var(--shadow-sm);
}

.agent {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-top-left-radius: 4px;
}

.user {
  background: var(--color-brand-primary);
  color: var(--color-text-on-brand);
  border-top-right-radius: 4px;
}

.user .plainText {
  color: var(--color-text-on-brand);
}

.meta {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}

.author {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.user .author {
  color: rgba(244, 247, 251, 0.85);
}

.agent .author {
  color: var(--color-brand-primary);
}

.time {
  font-size: 11px;
  opacity: 0.65;
}

.plainText {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14.5px;
  line-height: 1.55;
}

.typing {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

.typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-text-tertiary);
  animation: bounce 1.1s infinite ease-in-out;
}

.typing span:nth-child(2) {
  animation-delay: 0.15s;
}

.typing span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .bubble {
    max-width: 88%;
  }
}
